import {
  STRIPE_PAYMENT,
  STRIPE_PAYMENT_SUCCESS,
  STRIPE_PAYMENT_FAILURE,
} from "../actionTypes";

export const stripePayment = (payload) => ({
  type: STRIPE_PAYMENT,
  payload,
});

export const stripePaymentSuccess = (payload) => ({
  type: STRIPE_PAYMENT_SUCCESS,
  payload,
});

export const stripePaymentFailure = () => ({
  type: STRIPE_PAYMENT_FAILURE,
});